import { BaseService } from './base-service';
import { lastValueFrom } from 'rxjs';
export class ActivityTypesService {
    // ----------------------------------------------------------------------
    // Activity Types
    // ----------------------------------------------------------------------
    static getActivityTypes(filter, pageNumber) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return lastValueFrom(BaseService.getPaginated(`activity-types?filter=${qs}`, pageNumber));
    }
    static fetchActivityType(oid) {
        return lastValueFrom(BaseService.get(`activity-types/${oid}`));
    }
    static saveActivityType(dto) {
        return lastValueFrom(BaseService.save(`activity-types`, dto));
    }
    static deleteActivityType(oid) {
        return lastValueFrom(BaseService.delete(`activity-types/${oid}`));
    }
    static searchActivityTypeCombo(dossierTypeId, selfId, search) {
        let qs = encodeURIComponent(search);
        if (dossierTypeId == null)
            dossierTypeId = 0;
        return lastValueFrom(BaseService.get(`activity-types-combo/${dossierTypeId}/${selfId}?search=${qs}`));
    }
}
